import Typography from '@mui/material/Typography';
import React from 'react';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './navigation-count-badge.style';

export type NavigationCountBadgeProps = {
  count?: number;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

export const NavigationCountBadge: React.FC<NavigationCountBadgeProps> = ({
  count,
  icon,
}) => {
  if (icon) {
    return (
      <Styled.Container>
        <Icon icon={icon} />
      </Styled.Container>
    );
  }

  // `undefined` means the counts provider has not published yet — render
  // nothing rather than a zero.
  return !!count ? (
    <Styled.Container>
      <Typography variant="overline" component="span">
        {count}
      </Typography>
    </Styled.Container>
  ) : null;
};
